import { render, staticRenderFns } from "./assignarchivalmodal.vue?vue&type=template&id=425fdb5e&scoped=true&"
import script from "./assignarchivalmodal.vue?vue&type=script&lang=js&"
export * from "./assignarchivalmodal.vue?vue&type=script&lang=js&"
import style0 from "./assignarchivalmodal.vue?vue&type=style&index=0&id=425fdb5e&prod&lang=scss&scoped=true&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425fdb5e",
  null
  
)

export default component.exports